import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const Header = ({ children, className }) => {
  const classes = classNames({
    'create-wizard-layout-header': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

Header.propTypes = propTypes;

export default Header;
